import Header from './components/Header';
import Hero from './components/Hero';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FeaturesSection />
        <FaqSection />
        <AppSection />
        <TopicsSection />
        <MediaSection />
        <ContactSection />
        <RankingSection />
        <AboutSection />
        <IndexSection />
        <CardsSection />
        <UpdatesSection />
        <CommentsSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}